import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/clinic/(defaultLayout)/(listing)/prescriberslisting/_components/get-in-touch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/clinic/(defaultLayout)/doctor/[id]/_components/TabContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
